import * as React from "react"

export default function FindPlanIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.02 11.078l2.856 2.855-.943.943-2.855-2.855a6.002 6.002 0 01-9.745-4.687c0-3.313 2.688-6 6-6a6.002 6.002 0 014.688 9.744z"
        fill={props.fill}
      />
    </svg>
  )
}

